module.exports = __webpack_public_path__ + "media/application/images/svgs/monitor-f10e7e2e8fe02fe23d4fc0689871ef73.svg";